export default __webpack_public_path__ + "static/media/cargando.35e9311d.gif";